export function StressTestingPage() {
  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-semibold">Stress Testing</h1>
      <p className="text-muted-foreground">Run stress tests on the platform.</p>
    </div>
  );
}
